import { useTranslation } from '@framework/i18n';
import { Dropdown } from '@framework/ui';
import { MenuProps } from 'antd';
import { useMemo } from 'react';
import { ItaliaButton } from '../components/ItaliaButton';
import { useEntitiesIdp } from '../hooks/useEntitiesIdp';
import {
  type ProfessionalSpidPurpose,
  useGetIdpAuthUrlFn,
} from '../hooks/useGetIdpAuthUrlFn';
import { IdpMenuLabel } from './IdpMenuLabel';

export interface ISpidLoginButtonProps {
  resolvePublicUrl: (path: string) => string;
  fullWidth?: boolean;
  purpose?: ProfessionalSpidPurpose;
  text?: string;
}

export function SpidLoginButton(props: ISpidLoginButtonProps) {
  const { resolvePublicUrl, fullWidth, purpose, text } = props;
  const { t } = useTranslation();

  // Estraiamo i provider SPID dall'API senza riordinarli
  // per essere conformi con l'implementazione ufficiale
  const { data: spidProviders } = useEntitiesIdp();

  const getUrl = useGetIdpAuthUrlFn({
    idpMethod: 'SPID',
    resolvePublicUrl,
    purpose,
  });

  const menu = useMemo(() => {
    const result: MenuProps = {
      items: spidProviders.map(provider => ({
        key: provider.entity_id,
        // title: provider.organization_display_name,
        label: (
          <IdpMenuLabel>
            <a href={getUrl(provider.entity_id)} style={{ display: 'block' }}>
              <img
                src={provider.logo_uri}
                alt={`${provider.organization_name} - ${provider.organization_display_name}`}
              />
            </a>
          </IdpMenuLabel>
        ),
      })),
    };
    return result;
  }, [getUrl, spidProviders]);

  return (
    <Dropdown
      menu={menu}
      placement="bottomLeft"
      autoAdjustOverflow={false}
      trigger={['click']}
      overlayClassName="no-padding-dropdown-overlay"
    >
      <ItaliaButton
        style={fullWidth ? { width: '100%' } : undefined}
        image={require('../../../assets/img/spid-ico-circle-bb.svg')}
        text={text ?? t('user.login.spid-button', 'Entra con SPID')}
      />
    </Dropdown>
  );
}
